import React, { memo, useState } from 'react'
import styled from 'styled-components'
import SizeSystem from './SizeSystem'
import { Spinner } from 'react-bootstrap'

export const StyledArrowWrapper = styled.div`
  display:flex;
  cursor:pointer;
`
const SizeSystems = memo(({ sizeSystems, loadingStates }) => {
  const [openSizeSystems, setOpenSizeSystems] = useState({})

  if (loadingStates.getSizeSystems) {
    return <div className="d-flex align-items-center justify-content-center"><Spinner animation='border' variant='primary' /></div>
  }
  return (
    <>
      {sizeSystems.map((sizeSystem, sizeSystemIndex) => (
        <SizeSystem
          key={sizeSystem.id}
          sizeSystem={sizeSystem}
          sizeSystemIndex={sizeSystemIndex}
          open={sizeSystems.length === 1 || openSizeSystems[sizeSystem.id]} // own prop
          setOpenSizeSystems={setOpenSizeSystems}
          hideSizeSystemInfo={sizeSystems.length === 1}
        />
      ))}
    </>
  )
})

export default SizeSystems